var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-pattern"},[_c('div',{ref:"back",staticClass:"page-container background-image"},[_c('div',{staticClass:"main-content"},[_vm._t("default")],2),_c('div',{staticClass:"footer-content"},[_c('p',{staticClass:"copyright"},[_vm._v("© Copyright "+_vm._s(new Date().getFullYear())+" Parcelex")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }